export var _comment = `
<b><i class="far fa-fw fa-comment"/> {{creator_resource.name}}</b>
<small class="text-muted mt-1">{{date created_at}} - {{formattime created_at}}</small><br>
{{text}}<br>
`;
